import React from 'react'
import { PieChart } from '@mui/x-charts/PieChart'
import { t } from 'i18next'
import { Card, Flex } from 'antd'
import Title from 'antd/es/typography/Title'

export default function CanceledChart ({ slots }) {
  const format = (slots, name) => {
    return { id: name, value: slots.length, label: t(`Admin.Statistic.CanceledChart.${name}`) }
  }

  const innerRadius = 40
  const middleRadius = 120

  const autoCanceled = slots.filter((s) => s.auto_cancel)
  const canceled = slots.filter((s) => s.is_cancel && !s.auto_cancel)
  const done = slots.filter((s) => !s.is_cancel && s.is_clean)

  return (
    <Card>
      <Flex vertical>
        <Title level={5} style={{ textAlign: 'center' }}>
          {`${slots.length} ${t('Admin.Statistic.CanceledChart.title')}`}
        </Title>
        <PieChart series={[
          {
            innerRadius,
            outerRadius: middleRadius,
            arcLabel: (item) => `${item.value} ${item.label}`,
            data: [
              format(autoCanceled, 'autoCanceled'),
              format(canceled, 'canceled'),
              format(done, 'done')
            ],
            cornerRadius: 3
          },
          {
            innerRadius: middleRadius,
            outerRadius: middleRadius + 30,
            data: [
              format(autoCanceled.filter((s) => !s.sms_confirmed), 'notConfirmed'),
              format(autoCanceled.filter((s) => s.sms_confirmed && s['late_cancel_already_send?']), 'lateCanceled'),
              format(autoCanceled.filter((s) => s.sms_confirmed && !s['late_cancel_already_send?']), 'notPresented'),
              format(canceled, 'canceled'),
              format(done.filter((s) => s['late_already_send?']), 'affectedByLate'),
              format(done.filter((s) => s.delayed), 'delayed'),
              format(done.filter((s) => !s.delayed && !s['late_already_send?']), 'done')
            ],
            cornerRadius: 3
          }
        ]} width={350} height={350} hideLegend />
      </Flex>
    </Card>
  )
}
